// API base URL. Must be provided via VITE_API_URL (see .env / deployment config).
// D12 (short-term): no hardcoded LAN-IP fallback — fail loud when unset so a
// misconfigured build is obvious instead of silently pointing at a dev machine.
const configuredApiUrl = import.meta.env.VITE_API_URL;

if (!configuredApiUrl) {
  throw new Error(
    'VITE_API_URL is not set. Configure it in your environment (.env) before building/running the frontend.'
  );
}

export const API_URL = configuredApiUrl;
